
import { CompactPageLayout } from 'common/components/compactPageLayout';
import ScreenTitle from 'common/components/screenTitle/ScreenTitle';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import DriverUserTab from 'screens/driver/components/driverUserTab/DriverUserTab';
import UsersList from './components/usersTab/components/usersList/UsersList';
import styles from './SecurityScreen.module.scss';

const SecurityScreen = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const { tabId, type, id } = useParams<{ tabId: string, type: string, id: string }>();

    return (
        tabId === 'users' && type ? <ScreenTitle title={t('users.title')}>
            <CompactPageLayout
                title={t('users.title') as string}
                contentAreaClassName={styles.contentArea}
                onBack={() => history.goBack()}
            >
                <DriverUserTab />
            </CompactPageLayout>
        </ScreenTitle>
            : <UsersList />
    );
}

export default SecurityScreen;
